module.exports = __webpack_public_path__ + "img/202505_07.0e6ac658.jpg";